import { useEffect, useState } from "react";
import RatingItem from "../../GlobalClassification/RatingItem";

import { CommonService } from "../../../../services/CommonService";
import IconDelete from "../../../../layout/others/icon-x.svg";

export default function PersonalSkillsAndCompetences({
  searchObject,
  setSearchObject,
  t
}) {
  const [personalSkills, setpersonalSkills] = useState([]);

  function onChangeSkillRanting(rating, id) {
    let _hardSkills = [...searchObject.personalSkills];
    let index = _hardSkills.map((skill) => skill.id).indexOf(id);
    if (index > -1) _hardSkills[index].rating = rating;
    setSearchObject({
      ...searchObject,
      personalSkills: _hardSkills
    });
  }

  useEffect(
    () => CommonService.getAllSkills().then((data) => setpersonalSkills(data)),
    []
  );

  useEffect(() => {
    initiatePersonalSkills();
  }, [personalSkills]);

  function initiatePersonalSkills() {
    if (
      !searchObject.personalSkills ||
      searchObject.personalSkills.length === 0
    )
      if (personalSkills && personalSkills.length > 0) {
        let _personnalSkills = personalSkills.map((skill) => {
          return {
            description: skill.description,
            id: skill.id,
            rating: 0
          };
        });
        setSearchObject({
          ...searchObject,
          personalSkills: _personnalSkills
        });
      }
  }

  function clearRating() {
    if (personalSkills && personalSkills.length > 0) {
      let _personnalSkills = personalSkills.map((skill) => {
        if (skill.rating !== "") {
          return {
            description: skill.description,
            id: skill.id,
            rating: 0
          };
        }
      });
      setSearchObject({
        ...searchObject,
        personalSkills: _personnalSkills
      });
    }
  }

  return (
    <div>
      <legend className="fontsize-legend">
        {t("Personal Skills and Competences")}
      </legend>
      <div className="row">
        <div className="col-9">
          {searchObject.personalSkills &&
            searchObject.personalSkills.map((skill) => (
              <div className="row" key={skill.id}>
                <div className="col fontsize-legend">
                  {t(skill.description)}
                </div>
                <div className="col">
                  <RatingItem skill={skill} onChange={onChangeSkillRanting} />
                </div>
              </div>
            ))}
        </div>
        {searchObject.personalSkills &&
          searchObject.personalSkills.filter((skill) => skill.rating > 0)
            .length > 0 && (
            <button
              onClick={clearRating}
              className="btn-mobile clear-competences-skills "
            >
              <img
                src={IconDelete}
                alt="ico-ppl"
                height="12px"
                width="auto"
                style={{ height: "14px", marginTop: "5px" }}
              />
              <a className="clear-button">{t("Clear")}</a>
            </button>
          )}
      </div>
    </div>
  );
}
